import { useCallback } from 'react';
import { type LinkProps } from 'react-router-dom';

type UseHandleLinkClickProps = Pick<LinkProps, 'onClick' | 'target' | 'to'>;

export const useHandleLinkClick = ({ onClick, target, to }: UseHandleLinkClickProps) => {
    const handleClick: React.MouseEventHandler<HTMLAnchorElement> = useCallback((e) => {
        if (onClick) {
            onClick(e);
        }

        if (target === '_blank' && typeof to === 'string') {
            e.preventDefault();
            window.open(to);
        }
    }, [onClick, target, to]);

    return handleClick;
};